const Label = ({children, className}) => {
  return (
    <label className={`mues_grey_I  
    mues_font_weight_500 mues_one_line_clamp 
    mues_pointer ${className}`}>{children}</label>
  )
}

export default Label